import type { GetProductsResItem0PricingItemDto } from '@travelity/api/generated';
import { getMinPriceFromDualCurrency } from './getMinPriceFromDualCurrency';

type MinPriceWithCurrency = {
    minPrice: number;
    currency: string;
};

export const getMinPriceFromDualCurrencyItems = (
    pricingItems?: GetProductsResItem0PricingItemDto[]
): MinPriceWithCurrency => {
    let value = {
        minPrice: 0,
        currency: '',
    };
    if (!pricingItems) return value;

    for (const pricingItem of pricingItems) {
        const minPrice = getMinPriceFromDualCurrency(
            pricingItem.price.original
        );
        const currency = pricingItem.currency.abbr;

        value = {
            minPrice,
            currency,
        };
    }

    return value;
};
